import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SiteMode } from '@shared/services/hostMode.service';

@Component({
  selector: 'app-host-mode-label',
  standalone: true,
  template: `
    @if (siteMode() === 'EXPERT') {
      <div class="label site-mode expert" title="Expert">
        <span>E</span>
      </div>
    }

    @if (siteMode() === 'ADVANCED') {
      <div class="label site-mode advanced" title="{{ 'Advanced' | translate }}">
        <span>A</span>
      </div>
    }
  `,
  imports: [TranslatePipe],
  styleUrls: ['./host-mode-label.component.scss'],
})
export class HostModeLabelComponent {
  public siteMode = input.required<SiteMode>();
}
